import React from 'react';
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg';
import { locationItemImages } from '../../../constants/constants';

interface LocationItem {
	id: string;
	code: string;
	name?: string;
	isFound: boolean;
}

interface JourneySlidePanelProps {
	show: boolean;
	onClose: () => void;
	progress: {
		foundItems: number;
		totalItems: number;
	} | null;
	locationItems: LocationItem[];
}

const JourneySlidePanel: React.FC<JourneySlidePanelProps> = ({ show, onClose, progress, locationItems }) => {
	return (
		<div
			className='absolute bottom-0 left-0 w-full z-40 rounded-t-2xl transition-all duration-500 ease-in-out'
			style={{
				height: show ? '90%' : 0,
				backgroundImage: `url(${require('../../../assets/images/Journey/BaloonBackground.png')})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				overflow: 'hidden',
			}}
		>
			<div className='h-full flex flex-col m-4'>
				<div className='mb-4'>
					<div className='relative'>
						<button className='absolute top-0 w-8 h-8 rounded-full bg-darkenPurple flex items-center justify-center' onClick={onClose}>
							<CloseModalIcon />
						</button>

						<h2 className='text-[20px] leading-[26px] font-bold text-[#413F5E] text-center'>Journey Progress</h2>
					</div>

					<p className='mt-3 text-[15px] leading-[21px] font-classic text-[#413F5E] text-center'>We'll gather pieces across the map and build something that can lift us</p>

					<div className='mt-4 border-t border-b border-[#717171] py-3 flex justify-between items-center'>
						<span className='text-[14px] font-semibold text-[#413F5E]'>Details Found</span>
						<span className='text-[16px] leading-[21px] font-bold text-[#413F5E]'>
							{progress?.foundItems}/{progress?.totalItems}
						</span>
					</div>
				</div>

				<div className='flex-1 overflow-y-auto'>
					<div className='grid grid-cols-6 lg:grid-cols-9 gap-x-3 gap-y-3 lg:gap-y-7 pb-10'>
						{locationItems.map((item) => {
							const imageUri = locationItemImages[item.code ?? 'basketFrame'];

							return (
								<div key={item.id} className='flex justify-center'>
									<div className={`w-[60px] h-[60px] rounded-[14px] border-2 border-white flex items-center justify-center overflow-hidden bg-white/10 ${!item.isFound ? 'opacity-50' : ''}`}>
										{imageUri ? <img src={imageUri} alt={item.name} className='w-full h-full object-contain' /> : <span className='text-2xl font-bold text-gray-300'>?</span>}
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default JourneySlidePanel;
